/*
  PETRITE PRODUCT-PAGE DELIVERY BAR

  Keeps the delivery bar on a product page in step with the cart.

  The bar is rendered by snippets/free-shipping-bar.liquid, which reads the cart
  in Liquid. On a product page that value is fixed at page load, so adding to the
  cart would otherwise leave the bar stating a shortfall the customer has just
  closed. This subscribes to the theme's own cartUpdate event - the same one
  product-info, quick-order-list, quick-add-bulk, recipient-form and
  price-per-item already use - and re-renders the bar from the server so the
  arithmetic stays in Liquid rather than being duplicated here.

  It refetches the whole product section and keeps only this element's contents.
  That is heavier than a bespoke endpoint but it is the theme's established
  pattern, and it means the bar can never disagree with the cart drawer.
*/
if (!customElements.get('pdp-delivery-bar')) {
  customElements.define(
    'pdp-delivery-bar',
    class PdpDeliveryBar extends HTMLElement {
      connectedCallback() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.unsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      }

      disconnectedCallback() {
        if (this.unsubscriber) this.unsubscriber();
      }

      refresh() {
        const sectionId = this.dataset.sectionId;
        if (!sectionId) return;

        fetch(`${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}`)
          .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
          .then((text) => {
            const fresh = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('pdp-delivery-bar');
            // A cart emptied back to zero returns an empty bar, which is correct:
            // the snippet renders nothing without items.
            this.innerHTML = fresh ? fresh.innerHTML : '';
          })
          .catch(() => {
            /* Leave the last good render in place rather than blanking the bar. */
          });
      }
    }
  );
}
